import type { ISuffix } from './models';

/**
 * На основе числа выдает нужную форму слова
 * @example ```js
 * const getPluralFormOfProduct = count =>
 *   getCorrectSuffix(count, { form1: 'продукт', form2: 'продукта', form3: 'продуктов' });
 * getPluralFormOfProduct(0) // продуктов
 * getPluralFormOfProduct(1) // продукт
 * getPluralFormOfProduct(2) // продукта
 * getPluralFormOfProduct(5) // продуктов
 * getPluralFormOfProduct(10) // продуктов
 * ```
 */
export const getCorrectSuffix = (
    count: number | string | null,
    { form1, form2, form3 }: ISuffix
): string => {
    // Обрабатываем вариант, если число отрицательное
    const number = Math.floor(Math.abs(Number(count)));
    const oneAndAHalfNum = Number(count) % 10;

    if (form1 && form2 && form3) {
        const n10 = number % 10;
        const n100 = number % 100;

        if (n10 === 1 && n100 !== 11) {
            if (oneAndAHalfNum === 1.5) {
                return form2;
            }

            return form1;
        }

        if (n10 > 1 && n10 < 5 && (n100 < 10 || n100 > 19)) {
            return form2;
        }

        return form3;
    }

    return '';
};
